import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Paper,
  TableContainer,
  Button,
  Alert,
} from '@mui/material';
import api from '../services/api';

export default function FannotatorFilesPage() {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const fetchFiles = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.get('/admin/fannotator/files');
      setFiles(response.data);
      setErrorMsg('');
    } catch (err) {
      console.error(err);
      setErrorMsg('Failed to fetch fannotator files');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchFiles();
  }, [fetchFiles]);

  const handleView = (filename) => {
    navigate(`/fannotator-annotations/${filename}`);
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Fannotator Files
      </Typography>
      {errorMsg && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMsg}
        </Alert>
      )}
      {isLoading ? (
        <Box display="flex" justifyContent="center" my={4}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Filename</TableCell>
                <TableCell>Annotators</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {files.map((file) => (
                <TableRow key={file.filename}>
                  <TableCell>{file.filename}</TableCell>
                  <TableCell>{(file.annotators || []).join(', ')}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={() => handleView(file.filename)}
                    >
                      View Details
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
